import axios from 'axios'
import router from '../router'
import store from '../store'
import bus from '../utils/EventBus'
import { Message , Loading} from 'element-ui';

function setContentTypeIfUnset(headers, value) {
  headers['Content-Type'] = value
}

// 创建axios实例
const service = axios.create({
  // baseURL: process.env.BASE_API,
  timeout: 60000,
  withCredentials: true,

  //   transformRequest:(data,headers)=>{
  //     if(data){
  //       setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
  //       // let keys2 = Object.keys(data);
  //       // return encodeURI(keys2.map(name => `${name}=${data[name]}`).join('&'));
  //         setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
  //         return JSON.stringify(data);
  //     }
  // }

  // headers:{'Content-Type':'application/json;charset=utf-8'},
  // transformRequest: [function (data,headers) {
  //   // 对 data 进行任意转换处理
  //   setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
  //   return JSON.stringify(data);
  // }],
})

let loading;
function startLoading() {    //使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: '拼命加载中...',
    background:'rgba(255,255,255,0)',
  })
}
function endLoading() {    //使用Element loading-close 方法
  loading.close()
}

let that = this;
// request拦截器
service.interceptors.request.use(config => {
  // Do something before request is sent
  startLoading()
  var token = localStorage.getItem("token")
    if (token) {
      config.headers.common['authorization'] = token
    }
    console.log(token)
  return config
}, error => {
  // Do something with request error
  // console.log(error) // for debug
})
// respone拦截器
service.interceptors.response.use(
  response => {
    endLoading() 
    const { status, config } = response
    if (status === 200) {
      const data = response.data
      const msg = response.data.msg
      if (data.code === 1) {
        return response.data
      } else{
        Message.error({
          message: msg
        })
        return Promise.resolve(msg)
      }
    }
    if (status === 500) {
      const msg = '网络错误';
    }
    return Promise.reject(new Error('网络错误'))
  },
  /**
   * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
   * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
   */
  //  const res = response.data;
  //     if (res.code !== 20000) {
  //       Message({
  //         message: res.message,
  //         type: 'error',
  //         duration: 5 * 1000
  //       });
  //       // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
  //       if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
  //         MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
  //           confirmButtonText: '重新登录',
  //           cancelButtonText: '取消',
  //           type: 'warning'
  //         }).then(() => {
  //           store.dispatch('FedLogOut').then(() => {
  //             location.reload();// 为了重新实例化vue-router对象 避免bug
  //           });
  //         })
  //       }
  //       return Promise.reject('error');
  //     } else {
  //       return response.data;
  //     }
  error => {
    console.log('err:' + error.toString().indexOf('timeout')) // for debug
    if (error.toString().indexOf('timeout') >= 0) {
      bus.$emit('mainMsg', '请求超时，请检查网络情况');
      return;
    }
    if (error.response) {
      switch (error.response.status) {
        case 401:
          toLogin()
          break;
        case 400:

          break;
          case 500:
            bus.$emit('mainMsg', '发生了未知错误，错误代码：' + error.response.status);
          break;
        default:
          if (error.response.data.msg) {
            bus.$emit('mainMsg', '发生了未知错误，错误代码：' + error.response.status);
          } else if (error.response.data.message == "GENERAL") {
            bus.$emit('mainMsg', '发生了未知错误，错误代码：' + error.response.status);
          } else if((error.response.data.exception).indexOf('auth')){
            toLogin()
          }else{

          }
          break;
      }
    } else {
      if (error.toString().indexOf('timeout') >= 0) {
        bus.$emit('mainMsg', '服务器链接超时，请重试');
      } else if (error.toString().indexOf('Network') >= 0) {
        bus.$emit('mainMsg', '网络错误，请重试或重新登录');
        // toLogin();
      } else {
        bus.$emit('mainMsg', `未知错误[${error.toString()}]，请重试或重新登录`);
      }

    }
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)
const toLogin = () => {
  store.commit('REMOVE_ALL_COOKIES')
  bus.$emit('msg');
  router.replace({
    path: '/',
  })
}

export default service



// WEBPACK FOOTER //
// ./src/utils/fetch.js